module.exports = __webpack_public_path__ + "img/about_qr_code.5846da7c.jpg";